import axios from 'axios';

const appUrl = window.location.origin;
const urls = import.meta.env.VITE_LOCAL_HTTP_URLS
  ? import.meta.env.VITE_LOCAL_HTTP_URLS.split(',')
  : ['http://localhost:3000', 'http://10.0.2.2:3000'];

const baseUrl = urls.includes(appUrl)
  ? import.meta.env.VITE_APP_API_ENDPOINT
  : `${appUrl}/spa/`;

const apiClient = axios.create({
  baseURL: baseUrl,
  // withCredentials: true,
  headers: {
    Accept: 'application/json, text/plain, */*',
    'Content-type': 'application/json',
    'Referrer-Policy': 'strict-origin-when-cross-origin',
  },
});

apiClient.interceptors.request.use((config) => {
  const xsrftoken = sessionStorage.getItem('xsrftoken');
  const sessiontoken = sessionStorage.getItem('sessiontoken');

  if (xsrftoken) {
    config.headers.set('X-XSRF-TOKEN', xsrftoken);
  }

  if (sessiontoken) {
    config.headers.set('Session-Token', sessiontoken);
  }

  return config;
});

apiClient.interceptors.response.use((res) => {
  if (res.headers.get('resettokens')) {
    sessionStorage.removeItem('xsrftoken');
    sessionStorage.removeItem('sessiontoken');
  }

  const xsrf = res.headers.get('xsrftoken');
  if (xsrf && sessionStorage.getItem('xsrftoken') === null) {
    sessionStorage.setItem('xsrftoken', xsrf);
  }

  const session = res.headers.get('sessiontoken');
  if (session && sessionStorage.getItem('sessiontoken') === null) {
    sessionStorage.setItem('sessiontoken', session);
  }

  return res;
});

export default apiClient;
